import "./style.css";
import layout from "./layout.html";

export default class MarateaImages {
  static selector = ".maratea__images";

  constructor(block) {
    this.block = block;
    this.block.innerHTML = layout;
  }

  onReady = () => {};

  onComplete = () => {};

  onResize = () => {};
}
